// src/utils/userDataHelpers.ts
import { secureGetItem } from "./encryption";

export const getUserData = () => {
  try {
    return secureGetItem("userdata");
  } catch (error) {
    console.error("Error getting user data:", error);
    // Fallback to regular localStorage
    try {
      const dataString = localStorage.getItem("userdata");
      return dataString ? JSON.parse(dataString) : null;
    } catch (fallbackError) {
      console.error("Fallback also failed:", fallbackError);
      return null;
    }
  }
};

export const getUserId = () => {
  const data = getUserData();
  return data && data.length > 0 ? data[0]?.userdetail[0]?.useR_ID : null;
};

export const getUserDepartment = () => {
  const data = getUserData();
  return data && data.length > 0 ? {
    id: data[0]?.userdetail[0]?.departmentId,
    name: data[0]?.userdetail[0]?.department_Name
  } : null;
};

export const getUserPermissions = () => {
  const data = getUserData();
  return data && data.length > 0 ? data[0]?.userPermission : null;
};